import { ColumnProps } from 'antd/lib/table';
import { OptionalValue, Tooltip } from 'Components';
import {
	useCreateColumns,
	ColumnFilters
} from 'Components/Table/createColumns';
import {
	REPORT_FREQUENCIES,
	REPORT_FREQUENCIES_MAP
} from 'Pages/Report/EditReport/EditReport.constants';
import { useTranslation } from 'react-i18next';
import {
	GetSavedReportsRequest,
	SavedReport
} from 'Services/Api/Reports/Types';
import {
	STANDARD_REPORT_TYPES,
	STANDARD_REPORT_TYPE_MAP
} from '../../Standard/Standard.constants';
import ActionsButton from './ActionsButton';

type FilterValues = GetSavedReportsRequest;
export type TableFilterValues = ColumnFilters<FilterValues>;

type UseColumnsProps = {
	params: GetSavedReportsRequest | undefined;
	currentUserEmail: string;
};

const useColumns = <T extends SavedReport>(props: UseColumnsProps) => {
	const { t } = useTranslation();
	const columns: Array<ColumnProps<T>> = [
		{
			title: t('reports.tabs.saved.columns.name'),
			key: 'reportName',
			dataIndex: 'name'
		},
		{
			title: t('reports.tabs.saved.columns.reportType'),
			key: 'reportTypes',
			dataIndex: 'reportType',
			render: (_, record) =>
				STANDARD_REPORT_TYPE_MAP[record.reportType]?.label(t) ?? ''
		},
		{
			title: t('reports.tabs.saved.columns.recurrenceType'),
			key: 'recurrenceTypes',
			dataIndex: 'recurrenceType',
			render: (_, record) => (
				<OptionalValue>
					{record.recurrenceType &&
						t(REPORT_FREQUENCIES_MAP[record.recurrenceType]?.label)}
				</OptionalValue>
			)
		},
		{
			title: t('reports.tabs.saved.columns.emailsList'),
			key: 'emailsList',
			dataIndex: 'emailsList',
			render: (_, record) => {
				const [firstEmail, secondEmails, ...rest] = (record.emailsList || []);
				const otherEmails = rest?.length ? rest : [];
				const showToolTip = !!otherEmails.length;
				const label = `${firstEmail}${showToolTip ? ` +${otherEmails.length + 1} others`: secondEmails ? `, ${secondEmails}` : ""}`;
					
				return <Tooltip
					trigger={"hover"}
					placement="top"
					enabled={showToolTip}
					title={[secondEmails, ...otherEmails].join(", ")}
					overlayClassName="info-tooltip">
					<div>{firstEmail ? label : '-'}</div>
				</Tooltip>
			}
		},
		{
			title: "",
			width: 40,
			className: "action-btn",
			render: (_, record) => <ActionsButton report={record} isMobile={false} />
		}
	];
	return columns;
};

export default useColumns;
